import React from "react";
import "../../styles/Broadcast.css";

import { Input } from "../../../../components/form/Input/Input";
import { ICONS } from "../../../../assets/icons";

import SendForm from "./SendForm";
import RadioButton from "../../../../components/form/radio/RadioButton";
import { SendSettingList } from "../../../../constant/app/campaign/Broadcast";
import Calendar from "../../../../components/commonComponents/calendar/Calendar";
import { Popover, Tooltip } from "antd";
import moment from "moment";

import TimePickers from "./TimePickers";
import UpgradeBadge from "../../../../components/commonComponents/UpgradeBadge/UpgradeBadge";

// Feature Gating
import { useFunction } from "../../../../hooks/useFeatureGating";
import { FUNCTIONS } from "../../../../constant/featureSlugs";

const BroadSetting = ({
  handleCreateCampaign,
  handleClick,
  selectedRole,
  setSelectedRole,
  selectedItemId,
  numberDetails,
  handleLabelClick,
  selectedIndex,
  setSelectedIndex,
  broadCasts,
  setSelectedItemId,
  handleDateSelection,
  selectedDate,
  TimePick,
  setTimePick,
  startPopoverVisible,
  setStartPopoverVisible,
  handleTimeClick,
  selectedTime,
  campaignDetail,
  error,
  hours,
  minutes,
  periods,
  setHours,
  setPeriod,
  setMinutes,
  handleTime,
}) => {
  // Feature Gating: Check if Send Now and Send Later are enabled
  const { isEnabled: canSendNow, isLoading: sendNowLoading } = useFunction(
    FUNCTIONS.BROADCAST_SEND_NOW
  );
  const { isEnabled: canSendLater, isLoading: sendLaterLoading } = useFunction(
    FUNCTIONS.BROADCAST_SEND_LATER
  );

  const handlelabelClick = (dataName, isFeatureEnabled) => {
    // Don't allow selection if feature is disabled
    if (!isFeatureEnabled) {
      return;
    }

    const formattedName = dataName.toLowerCase().replace(/\s+/g, "_");
    setSelectedIndex(formattedName);
    handleLabelClick(formattedName);
  };

  // Show loading state while checking feature permissions
  if (sendNowLoading || sendLaterLoading) {
    return (
      <div className="BroadcastSetting-mainContainer flex-row">
        <div className="flex-column w-70">
          <div className="setting-wrapper">
            <span>Loading feature permissions...</span>
          </div>
        </div>
      </div>
    );
  }

  const handleOkClick = () => {
    setTimePick(false);
  };

  const currentDate = moment().format("YYYY-MM-DD");
  const content = (
    <Calendar
      heading="Select duration"
      singleSelect={true}
      clickedDateFunc={handleDateSelection}
    />
  );

  return (
    <div className="BroadcastSetting-mainContainer  flex-row">
      <div className="flex-column w-70 ">
        <div className="setting-wrapper">
          <span>Broadcast Name</span>
          <div className="mt-10">
            <Input
              placeholder="Enter broadcast name"
              pattern=""
              onChange={(e) => {
                const newValue = e?.target?.value?.replace(
                  /[^A-Za-z0-9-_ ]/g,
                  ""
                );
                handleCreateCampaign("name", newValue);
              }}
              value={broadCasts?.name}
              style={{ height: "5vh" }}
            />
          </div>
        </div>

        <div className="divider" />

        {/* Select Channels Div */}
        <div className="setting-wrapper flex-column">
          <span className="channels mt-10">Select Channels</span>
          <span>Select your communication channel</span>
          <div className="Broadcast-channel flex-row space-between pointer mt-10">
            <div className="flex-row align-center">
              <img
                src={ICONS?.WhatsApps}
                alt="whatsapp"
                style={{ width: "25px", height: "25px" }}
              />
              <span className="setting-whatsapp">WhatsApp</span>
            </div>
            <RadioButton selected={true} />
          </div>
        </div>

        <div className="divider" />

        {/* Send From Phone Number Component */}
        <div className="setting-wrapper flex-column mt-10">
          <SendForm
            numberDetails={numberDetails}
            handleClick={handleClick}
            setSelectedRole={setSelectedRole}
            selectedRole={selectedRole}
            selectedItemId={selectedItemId}
            setSelectedItemId={setSelectedItemId}
            broadCasts={broadCasts}
          />
        </div>

        <div className="divider" />

        {/* Send Setting Component */}
        <div className="flex-column">
          <div className="SendSetting-container flex-column">
            <div
              className="setting-wrapper flex-column"
              style={{ marginBottom: "0 !important" }}
            >
              <span>Send Setting</span>
              <span>When should we send this broadcast?</span>
            </div>

            {SendSettingList?.map((data) => {
              // Determine if this option is enabled based on feature flags
              const isFeatureEnabled =
                data?.name === "Send Now" ? canSendNow : canSendLater;

              // Check date validation (existing logic)
              const isDateInvalid =
                data?.name === "Send Now" &&
                (moment(
                  campaignDetail?.starting_date_and_time?.split("T")[0]
                ).isAfter(currentDate) ||
                  moment(currentDate).isAfter());

              // Combined disabled state
              const isDisabled = !isFeatureEnabled || isDateInvalid;

              return (
                <div
                  className="w-100 flex-column"
                  style={{ padding: "0px 20px" }}
                  key={data?.id}
                >
                  <div
                    className={`flex-row ${
                      isDisabled ? "" : "pointer"
                    }`}
                    onClick={() =>
                      isDisabled ? null : handlelabelClick(data?.name, isFeatureEnabled)
                    }
                    style={{
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <div className="flex-row items-start flex-1">
                      <label className="checkBoxContainer mb-10 mt-10" style={{ opacity: isDisabled ? 0.5 : 1 }}>
                        <input
                          type="checkbox"
                          name="checkbox"
                          checked={
                            selectedIndex ===
                            data?.name?.toLowerCase()?.replace(/\s+/g, "_")
                          }
                          onChange={() => {}}
                          disabled={isDisabled}
                        />
                      </label>
                      <div className="setting-setting flex-column">
                        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <span style={{ opacity: isDisabled ? 0.5 : 1 }}>{data?.name}</span>
                          {!isFeatureEnabled && <UpgradeBadge iconOnly={true} />}
                        </span>
                        <p style={{ opacity: isDisabled ? 0.5 : 1 }}>{data?.content}</p>
                      </div>
                    </div>
                  </div>

                  {/* Show date/time picker only for Send Later when selected */}
                  {data?.name === "Send Later" &&
                    selectedIndex === "send_later" &&
                    canSendLater && (
                      <div className="w-100 mt-10">
                        <div className="w-100 Broadcast-Time flex-row align-center">
                          <div
                            className="calender-card w-100 space-between flex-row"
                            style={{ padding: "5px 10px" }}
                          >
                            <div className="Calendar-container flex-row w-100 space-between">
                              <div className="aaaa flex-row align-center">
                                <span className="send-later-content pr-10">
                                  Date{" "}
                                </span>
                                <div>
                                  <Popover
                                    content={content}
                                    trigger="click"
                                    arrow={false}
                                    open={startPopoverVisible}
                                    onOpenChange={() => {
                                      setStartPopoverVisible(
                                        !startPopoverVisible
                                      );
                                      setTimePick(false);
                                    }}
                                  >
                                    <div className="flex-row align-center pointer">
                                      <Input
                                        type="none"
                                        placeholder={"DD/MM/YY"}
                                        iconPrefix={
                                          ICONS?.BroadcastCalendarIcon
                                        }
                                        style={{
                                          width: "7vw",
                                          fontSize: "0.75vw",
                                          fontWeight: "500",
                                          padding: "10px",
                                          color: "var(--textBlack)",
                                        }}
                                        value={selectedDate}
                                        readOnly
                                        className="pointer"
                                        name="calender"
                                      />
                                    </div>
                                  </Popover>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="input-container pointer pl-10"
                            style={{ position: "relative", marginLeft: "20px" }}
                          >
                            <div className="flex-row align-center">
                              <span className="send-later-content pr-10">
                                Time
                              </span>
                              <Popover
                                overlayClassName="time-popover"
                                content={
                                  <TimePickers
                                    hours={hours}
                                    minutes={minutes}
                                    periods={periods}
                                    setHours={setHours}
                                    setMinutes={setMinutes}
                                    setPeriod={setPeriod}
                                    onOkClick={() => handleTimeClick(TimePick)}
                                  />
                                }
                                trigger="click"
                                arrow={false}
                                open={TimePick}
                                onOpenChange={() => handleTime()}
                              >
                                <Input
                                  placeholder="00:00 AM"
                                  iconPrefix={ICONS?.BroadcastTimerIcon}
                                  style={{
                                    width: "7.5vw",
                                    cursor: "pointer",
                                    fontSize: "0.75vw",
                                    fontWeight: "500",
                                    padding: "10px",
                                  }}
                                  value={selectedTime || ""}
                                  className="pointer1"
                                />
                              </Popover>
                            </div>
                          </div>
                        </div>
                        {error && (
                          <div className="error-message flex-row align-center pl-10 ml-10 gap-2">
                            <img
                              src={ICONS?.alertIconError}
                              alt="alertIconError"
                            />
                            {error}
                          </div>
                        )}
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadSetting;
